import Api  from './Api'
import axios from 'axios'

class OwnEnrollmentDocumentsApi extends Api {
    async list(){
        const request = async () => await axios.get(this.generateAbsolutePath(`alumnos/inscripcion/documentos`));
            
        const { data } = await this.perform(request);

        return data;
    }

    async get(documentSlug){
        const request = async () => await axios.get(this.generateAbsolutePath(`alumnos/inscripcion/documentos/${documentSlug}`));

        const { data } = await this.perform(request);

        return data;
    }

    async store(documentSlug, data = {}){
        const request = async () => await axios.post(this.generateAbsolutePath(`alumnos/inscripcion/documentos/${documentSlug}`), data);

        await this.perform(request);
    }
}

export default OwnEnrollmentDocumentsApi;